// src/PrivacyPage.jsx
import React from "react";

const wrap = {
  minHeight: "100dvh",
  display: "grid",
  placeItems: "start center",
  background:
    "radial-gradient(1200px 600px at 10% -20%, rgba(0,176,116,0.04), transparent 50%), radial-gradient(800px 400px at 110% 120%, rgba(244,197,66,0.04), transparent 40%), #f8faf9",
  padding: 24,
};
const card = {
  width: "100%",
  maxWidth: 880,
  background: "#fff",
  borderRadius: 16,
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  padding: 24,
};
const h1 = { margin: 0 };
const meta = { color: "#667085", marginTop: 6, fontSize: 13 };
const h2 = { marginTop: 24 };
const p = { color: "#444", lineHeight: 1.6 };

export default function PrivacyPage() {
  return (
    <div style={wrap}>
      <article style={card}>
        <h1 style={h1}>Trelli Privacy Policy</h1>
        <div style={meta}>Last updated {new Date("2026-01-10").toLocaleDateString()}</div>

        <section>
          <p style={p}>
            Trelli, LLC (“Trelli,” “we,” “us,” or “our”) respects your privacy and is committed to
            protecting your personal information. This Privacy Policy explains how we collect, use,
            share, and protect information when you use the Trelli website, mobile applications, and
            related services (collectively, the “Services”).
          </p>
          <p style={p}>By using Trelli, you agree to the practices described in this Privacy Policy.</p>
        </section>

        <h2 style={h2}>1. Information We Collect</h2>
        <p style={p}>
          We collect information to provide financial services, comply with legal obligations, and
          improve our Services.
        </p>

        <h2 style={h2}>a. Information You Provide</h2>
        <p style={p}>
          We may collect identity information (such as name, date of birth, address, email, and phone
          number), verification information (such as government ID details when required), account
          information you provide, and communications you send to us (including support requests).
        </p>

        <h2 style={h2}>b. Financial Information (Trelli Accounts)</h2>
        <p style={p}>
          When you open and use a Trelli account, we collect information related to your Trelli-hosted
          financial features, such as balances, transactions, transfers, bill payments, card activity,
          and virtual card/budget control activity.
        </p>

        <h2 style={h2}>c. External Financial Account Information (Optional – Plaid)</h2>
        <p style={p}>
          If you enroll in Trelli Plus or otherwise choose to connect external financial accounts, you
          authorize us to access information from those institutions through Plaid, Inc. (“Plaid”).
          Depending on your permissions, this may include account balances, transaction history, and
          account type and institution name. Trelli does not store your bank login credentials.
        </p>

        <h2 style={h2}>d. Information from Service Providers (Stripe and others)</h2>
        <p style={p}>
          We receive information from service providers that support our Services, including Stripe,
          Inc. (for account creation, payments, card issuance, identity verification, and compliance),
          Plaid (if you opt in), and cloud infrastructure and security providers.
        </p>

        <h2 style={h2}>e. Technical and Usage Information</h2>
        <p style={p}>
          We may automatically collect device information, IP address, browser type, app/website usage
          data, and cookies or similar technologies used for security, fraud prevention, and
          functionality.
        </p>

        <h2 style={h2}>2. How We Use Information</h2>
        <p style={p}>
          We use information to create and manage your account, verify identity, provide financial
          features, process transactions and bill payments, display insights (including optional
          external account insights), prevent fraud, communicate with you, and improve our Services.
        </p>

        <h2 style={h2}>3. How We Share Information</h2>
        <p style={p}>
          We do not sell your personal information. We share information only as needed to operate
          Trelli and comply with the law, including sharing with service providers such as Stripe and
          Plaid (if you opt in), and with legal/regulatory authorities when required.
        </p>

        <h2 style={h2}>4. Data Security</h2>
        <p style={p}>
          We use administrative, technical, and physical safeguards designed to protect your
          information. No system can be guaranteed to be completely secure.
        </p>

        <h2 style={h2}>5. Your Choices and Rights</h2>
        <p style={p}>
          You may access and update certain information through your account, disconnect external
          accounts (if enabled), and request access, correction, or deletion of certain information,
          subject to legal and regulatory requirements.
        </p>

        <h2 style={h2}>6. Data Retention</h2>
        <p style={p}>
          We retain information as long as necessary to provide the Services and comply with legal,
          regulatory, and accounting obligations, then securely delete or anonymize it.
        </p>

        <h2 style={h2}>7. Children’s Privacy</h2>
        <p style={p}>
          Trelli is not intended for children under 13. If we learn we collected information from a
          child under 13 without appropriate consent, we will take steps to delete it.
        </p>

        <h2 style={h2}>8. Changes to This Policy</h2>
        <p style={p}>
          We may update this Privacy Policy from time to time. If we make material changes, we will
          notify you through the Services or by other appropriate means.
        </p>

        <h2 style={h2}>9. Contact Us</h2>
        <p style={p}>
          Email: hello@usetrelli.com
        </p>
      </article>
    </div>
  );
}